@if (turns().length > 0) {
  <!-- Thread summary -->
  @if (getThreadSummary(); as summary) {
    <div class="thread-summary">
      <span class="summary-item">{{ summary.totalCost }}</span>
      <span class="summary-sep">|</span>
      <span class="summary-item">{{ summary.turnCount }} turns</span>
      <span class="summary-sep">|</span>
      <span class="summary-item">{{ summary.totalDuration }}</span>
    </div>
  }

  <!-- Turn selector pills -->
  @if (getAssistantTurns(); as assistantTurns) {
    @if (assistantTurns.length > 0) {
      <div class="turn-strip hide-scrollbar">
        @for (at of assistantTurns; track at.originalIndex) {
          <button class="turn-pill"
            [class.selected]="isSelectedTurn(at.originalIndex)"
            (click)="selectTurn(at.originalIndex)">
            <span class="pill-number">{{ at.turnNumber }}</span>
            <span class="pill-info">{{ at.duration }} {{ at.cost }}</span>
          </button>
        }
      </div>
    }
  }

  <!-- Debug sections for selected turn -->
  <div class="debug-content hide-scrollbar">
    @if (hasLimitedDebug()) {
      <div class="limited-notice">{{ ss.t('meo_debugLimited') }}</div>
    }
    @for (section of getSections(); track section.key) {
      <div class="debug-section" [class]="section.colorClass || ''">
        <button class="section-header" (click)="toggleSection(section.key)">
          <span class="section-chevron" [class.collapsed]="isSectionCollapsed(section.key)">&#9662;</span>
          <span class="section-icon">{{ section.icon }}</span>
          <span class="section-label">{{ section.label }}</span>
        </button>
        @if (!isSectionCollapsed(section.key)) {
          <div class="section-body">
            @for (entry of section.entries; track $index) {
              <div class="debug-entry" [class]="entry.colorClass || ''">
                @if (entry.key) {
                  <span class="entry-key">{{ entry.key }}{{ entry.value ? ':' : '' }}</span>
                }
                @if (entry.value) {
                  <span class="entry-value" [class.complex]="entry.isComplex">{{ entry.value }}</span>
                }
              </div>
            }
          </div>
        }
      </div>
    }

    @if (getSections().length === 0) {
      <div class="debug-empty">{{ ss.t('meo_noDebugThisTurn') }}</div>
    }
  </div>
} @else {
  <div class="debug-empty">{{ ss.t('meo_noDebugLastResponse') }}</div>
}
